// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"49a785fe","86":"81b03a75","416":"8a9f9344","863":"8b35ec77"}[chunkId] + ".css";
};